// Note this needs to be a .js file because it gets loaded in the next.config.js file
// contentConfig.js

import { PublicSettings } from "@/src/config/PublicSettings";
import {
    adviceSubmenus,
    coverageSubmenus,
    footerAdviceSubmenus,
    footerFAQsSubmenus,
    footerLocationsSubmenus,
    petSubmenus,
    employerSubmenus,
    footerCompanySubmenus,
    footerResourcesSubmenus
} from "@/src/data/menus";

/**
 * @type {import("@/src/@types/Settings").IContentConfig}
 */
const contentConfig = {
    //Compare page
    compareWidget: [
        {
            id: "hero",
            subheading:
                "Dive into our comprehensive pet insurance comparison to see how Spot's offerings measure up against other providers. Our guide simplifies comparing pet insurance, highlighting key differences and benefits. Discover the crucial factors that set Spot plans apart in the pet insurance landscape, helping ensure you make an informed decision for your pet's health and well-being."
        },
        {
            id: "options",
            subheading:
                "Choosing pet insurance involves comparing key factors including policies, coverage differences, claim eligibility, and reimbursement rates. Understanding these factors is crucial when determining the coverage and cost-effectiveness of your pet's health care, as these differences can greatly influence the coverage of your claims and the reimbursement amount after veterinary visits. When looking at pet insurance, consider the following:"
        },
        {
            id: "columns",
            columns: [
                {
                    id: "column1",
                    heading: "Coverage",
                    subheading:
                        "Spot offers two main plans: Accident & Illness coverage, addressing a broad range of health concerns, and the Accident Only plan, catering specifically to unexpected injuries. Spot also offers optional preventive care plans with coverage available for routine exams, dental cleanings, and spaying or neutering."
                },
                {
                    id: "column2",
                    heading: "Deductibles",
                    subheading:
                        "Spot's insurance plans incorporate a deductible, a predetermined amount that must be paid before coverage applies to eligible veterinary expenses. As a policyholder you retain the ability to select the deductible amount, tailoring the plan to align with your preferences and financial considerations."
                },
                {
                    id: "column3",
                    heading: "Reimbursement",
                    subheading:
                        "Spot offers reimbursement rates of 70%, 80%, or 90% on eligible vet bills. You’ll need to meet your deductible first before reimbursements are paid out. Allowing you to choose the reimbursement amount, gives you the added flexibility to customize your plan to best fit your pet health and budget needs."
                },
                {
                    id: "column4",
                    heading: "Pre-existing Conditions",
                    subheading:
                        "We don't cover pre-existing conditions, and typically, neither does anyone else. However, unlike some other pet insurance providers, Spot plans can cover curable, pre-existing conditions, as long as they are treatment and symptom free for at least 180 days, excluding pre-existing knee and ligament conditions."
                }
            ]
        }
    ],
    compareChartDisclaimer: `Comparison information is provided using publicly available information as of 3/2/24 and is only meant to summarize program features, not a specific plan. Review each provider’s plan terms for more details. The descriptions of other providers’ plans were not provided by that company. If you have questions about other plans, please contact an agent of that company. It is our intention to provide fair and accurate comparison information. Although we attempt to keep information up to date, it may change from time to time. If you are aware of any inaccuracies or changes in the information provided, let us know by emailing ${PublicSettings.SPOT_MARKETING_EMAIL}.`,
    displaySpotPlanComparison: true,
    displayWeTakeCare: true,
    citationLink: true,
    displayTrustPilot: true,
    displayAccolades: true,
    licensedVet: "Get vet treatment in the US or Canada.",
    claimSubmission: "Send us your bill online, in our app, or via fax.",
    displayPlanOptionsCTA: true,
    //Policy Inclusions modal
    policyInclusionsModal: [
        {
            heading: "What’s Covered?",
            description:
                "Each type of coverage includes exam fees, diagnostics, and treatment. We even cover the most advanced treatments, like chemotherapy and surgery, and some you may not expect, such as stem-cell therapy and acupuncture, so you can follow your vet’s recommendations with less worry about cost."
        },
        {
            heading: "Accidents",
            description:
                "Accident coverage will take care of costs for injuries and emergencies related to accidents, like bite wounds, cuts, broken bones, lodged foreign objects, and toxic ingestions."
        },
        {
            heading: "Illnesses",
            description:
                "With illness coverage, you’ll be reimbursed for the costs of major and minor illnesses, such as cancer, arthritis, allergies, hypothyroidism, digestive problems, and UTIs."
        },
        {
            heading: "Hereditary & Congenital Conditions",
            description:
                "This coverage is for the costs of inherited conditions and birth defects that don’t show symptoms until later in your pet’s life, like heart disease, IVDD, eye disorders, and hip dysplasia."
        },
        {
            heading: "Behavioral Issues",
            description:
                "Behavioral issues coverage can help with the costs of vet visits for concerning behaviors that may be related to anxiety or compulsive behavior, like excessive licking, fur pulling, and destruction of the home."
        },
        {
            heading: "Sample policy",
            description: "View our sample policy by ",
            link: { url: "/sample-policy", text: "clicking here" }
        }
    ],
    // Menus
    menus: {
        siteHeader: [
            { title: "Pet Insurance", href: undefined, submenu: petSubmenus },
            { title: "Coverage", href: undefined, submenu: coverageSubmenus },
            { title: "Advice", href: undefined, submenu: adviceSubmenus },
            { title: "Employer Benefits", href: undefined, submenu: employerSubmenus },
            { title: "Spot Perks", href: "/spot-perks" }
        ],
        siteFooter: [
            { title: "Pet FAQs", links: footerFAQsSubmenus },
            { title: "Pet Insurance by State", links: footerLocationsSubmenus },
            { title: "Pet Advice", links: footerAdviceSubmenus },
            { title: "Resources", links: footerResourcesSubmenus },
            { title: "Company", links: footerCompanySubmenus }
        ]
    },
    lowestPolicyPrice: "7" //https://quote.spotpet.com/?quoteId=38539acb-f2c9-ef11-88cf-6045bd483d78 - Quote on 01/03/2025 - Male Cat - Domestic Shorthair Mix - 8 weeks to 11 Months - Accident Only - 70% reimbursement - $1000 deductible
};
export default contentConfig;
